export const misc = [
  {
    name: 'Doge',
    icon: 'icon icon-doge',
  },
  {
    name: 'Creditcards',
    icon: 'icon icon-credit-cards',
  },
  {
    name: 'Misc',
    icon: 'icon icon-misc2',
  },
  {
    name: 'CTA Client Choice',
    icon: 'icon icon-cta-client-choice',
  },
  {
    name: 'Miscellaneous',
    icon: 'icon icon-misc',
  },
  {
    name: 'Hand Rock',
    icon: 'fa fa-hand-rock-o',
  },
  {
    name: 'Hand Lizard',
    icon: 'fa fa-hand-lizard-o',
  },
  {
    name: 'Hand Down',
    icon: 'fa fa-hand-o-down',
  },
  {
    name: 'Hand Left',
    icon: 'fa fa-hand-o-left',
  },
  {
    name: 'Hand Right',
    icon: 'fa fa-hand-o-right',
  },
  {
    name: 'Hand Up',
    icon: 'fa fa-hand-o-up',
  },
  {
    name: 'Hand Paper',
    icon: 'fa fa-hand-paper-o',
  },
  {
    name: 'Hand Peace',
    icon: 'fa fa-hand-peace-o',
  },
  {
    name: 'Hand Pointer',
    icon: 'fa fa-hand-pointer-o',
  },
  {
    name: 'Hand Scissors',
    icon: 'fa fa-hand-scissors-o',
  },
  {
    name: 'Hand Spock',
    icon: 'fa fa-hand-spock-o',
  },
  {
    name: 'Hand Stop',
    icon: 'fa fa-hand-stop-o',
  },
  {
    name: 'Thumbs Down',
    icon: 'fa fa-thumbs-down',
  },
  {
    name: 'Thumbs Up',
    icon: 'fa fa-thumbs-up',
  },
  {
    name: 'Ambulance',
    icon: 'fa fa-ambulance',
  },
  {
    name: 'Auto Mobile',
    icon: 'fa fa-automobile',
  },
  {
    name: 'Bicycle',
    icon: 'fa fa-bicycle',
  },
  {
    name: 'Bus',
    icon: 'fa fa-bus',
  },
  {
    name: 'Fighter Jet',
    icon: 'fa fa-fighter-jet',
  },
  {
    name: 'Motor Cycle',
    icon: 'fa fa-motorcycle',
  },
  {
    name: 'Plane',
    icon: 'fa fa-plane',
  },
  {
    name: 'Rocket',
    icon: 'fa fa-rocket',
  },
  {
    name: 'Ship',
    icon: 'fa fa-ship',
  },
  {
    name: 'Space Shuttle',
    icon: 'fa fa-space-shuttle',
  },
  {
    name: 'Subway',
    icon: 'fa fa-subway',
  },
  {
    name: 'Taxi',
    icon: 'fa fa-taxi',
  },
  {
    name: 'Train',
    icon: 'fa fa-train',
  },
  {
    name: 'Truck',
    icon: 'fa fa-truck',
  },
  {
    name: 'Wheelchair',
    icon: 'fa fa-wheelchair',
  },
  {
    name: 'Amex',
    icon: 'fa fa-cc-amex',
  },
  {
    name: 'Diners Club',
    icon: 'fa fa-cc-diners-club',
  },
  {
    name: 'Discover',
    icon: 'fa fa-cc-discover',
  },
  {
    name: 'Jcb',
    icon: 'fa fa-cc-jcb',
  },
  {
    name: 'Master Card',
    icon: 'fa fa-cc-mastercard',
  },
  {
    name: 'Paypal',
    icon: 'fa fa-cc-paypal',
  },
  {
    name: 'Stripe',
    icon: 'fa fa-cc-stripe',
  },
  {
    name: 'Visa',
    icon: 'fa fa-cc-visa',
  },
  {
    name: 'Credit Card',
    icon: 'fa fa-credit-card',
  },
  {
    name: 'Google Wallet',
    icon: 'fa fa-google-wallet',
  },
  {
    name: 'Bluetooth',
    icon: 'fa fa-bluetooth',
  },
  {
    name: 'Slide Share',
    icon: 'fa fa-slideshare',
  },
  {
    name: 'Wpforms',
    icon: 'fa fa-wpforms',
  },
  {
    name: 'Flickr',
    icon: 'fa fa-flickr',
  },
  {
    name: 'Amazon',
    icon: 'fa fa-amazon',
  },
  {
    name: 'Android',
    icon: 'fa fa-android',
  },
  {
    name: 'Apple',
    icon: 'fa fa-apple',
  },
  {
    name: 'American Sign Language Interpreting',
    icon: 'fa fa-asl-interpreting',
  },
  {
    name: 'Assitive listening System',
    icon: 'fa fa-assistive-listening-systems',
  },
  {
    name: 'Blind',
    icon: 'fa fa-blind',
  },
  {
    name: 'Braille',
    icon: 'fa fa-braille',
  },
  {
    name: 'Deaf',
    icon: 'fa fa-deaf',
  },
  {
    name: 'Low Vision',
    icon: 'fa fa-low-vision',
  },
  {
    name: 'Question Circle',
    icon: 'fa fa-question-circle-o',
  },
  {
    name: 'Sign Language',
    icon: 'fa fa-sign-language',
  },
  {
    name: 'Tty',
    icon: 'fa fa-tty',
  },
  {
    name: 'Universal Access',
    icon: 'fa fa-universal-access',
  },
  {
    name: 'Volume Control phone',
    icon: 'fa fa-volume-control-phone',
  },
  {
    name: 'Check Square',
    icon: 'fa fa-check-square',
  },
  {
    name: 'Circle',
    icon: 'fa fa-circle',
  },
  {
    name: 'Dot Circle',
    icon: 'fa fa-dot-circle-o',
  },
  {
    name: 'Minus Square',
    icon: 'fa fa-minus-square',
  },
  {
    name: 'Plus Square',
    icon: 'fa fa-plus-square',
  },
  {
    name: 'Square',
    icon: 'fa fa-square',
  },
];

export const miscIconMap = {};
misc.forEach(({ name, icon }) => {
  miscIconMap[name] = icon;
});

export const miscNames = misc.map(({ name }) => name);
